const cyNav = [{
     "id": 11,
     "label": "概况",
     "icon": "icon-gaikuang1",
     "select": false,
     "path": "survey",
     "data": [
       {
         "id": 1101,
         "label": "报表",
         "children": [{
             "id": 110101,
             "label": "营业概况",
             "path": "survey",
             "select": false,
             "navTitle": "报表/营业概况"
           },
           {
             "id": 110103,
             "label": "交易排行",
             "path": "transactionranking",
             "select": false,
             "navTitle": "报表/交易排行"
           }
         ]
       }
     ]
   },
   {
     "id": 12,
     "label": "基础",
     "icon": "icon-jichu",
     "select": false,
     "path": "employees",
     "data": [
       {
         "id": 1201,
         "label": "基础",
         "select": false,
         "children": [
           {
             "id": 120102,
             "label": "商品档案",
             "select": false,
             "path": "commodity",
             "navTitle": "基础/商品档案"
           },
           // {
           //   "id": 120103,
           //   "label": "商品组合",
           //   "select": false,
           //   "navTitle": "基础/商品组合",
           //   "path": "assortedGoods"
           // }, {
           //   "id": 120104,
           //   "label": "单位信息",
           //   "select": false,
           //   "path": "unitinformation",
           //   "navTitle": "基础/单位信息"
           // },
           {
             "id": 120110,
             "label": "员工档案",
             "path": "employees",
             "select": false,
             "navTitle": "基础/员工档案"
           },
           // {
           //   "id": 120111,
           //   "label": "员工权限",
           //   "path": "employeeauthority",
           //   "select": false,
           //   "navTitle": "基础/员工权限"
           // },
           {
             "id": 120112,
             "label": "餐桌管理",
             "path": "tableAdmin",
             "select": false,
             "navTitle": "基础/餐桌管理"
           },

         ]
       }
     ]
   },
   {
     "id": 14,
     "label": "零售",
     "icon": "icon-lingshou",
     "select": false,
     "path": "businessoverview",
     "data": [
       {
         "id": 1401,
         "label": "报表",
         "seats": false,
         "children": [{
             "id": 140107,
             "label": "经营概况",
             "path": "businessoverview",
             "navTitle": "报表/经营概况"
           },
           {
             "id": 140101,
             "label": "交班对账",
             "path": "employeeHandover",
             "navTitle": "报表/交班对账"
           },

           {
             "id": 140106,
             "label": "门店收款",
             "path": "storecollection",
             "navTitle": "报表/门店收款"
           },

           // {
           //   "id": 140102,
           //   "label": "收款明细",
           //   "path": "documentdetailsone",
           //   "navTitle": "报表/收款明细"
           // },
           {
             "id": 140103,
             "label": "单据明细",
             "path": "retaildetails",
             "navTitle": "报表/单据明细"
           },
           {
             "id": 140104,
             "label": "商品明细",
             "path": "documentdetailsa",
             "navTitle": "报表/商品明细"
           },
           {
             "id": 140105,
             "label": "商品汇总",
             "path": "productsummary",
             "navTitle": "报表/商品汇总"
           }
         ]
       },
     ]
   },
   {
     "id": 15,
     "label": "会员",
     "icon": "icon-huiyuan",
     "seats": false,
     "path": "memberpro",
     "data": [
       {
         "id": 1501,
         "label": "操作",
         "seats": false,
         "children": [{
             "id": 150101,
             "label": "会员档案",
             "path": "memberpro",
             "navTitle": "操作/会员档案"
           },
         ]
       }, {
         "id": 1502,
         "label": "报表",
         "seats": false,
         "children": [{
           "id": 150201,
           "label": "会员余额",
           "path": "memberbalance",
           "navTitle": "报表/会员余额"
         }, {
           "id": 150202,
           "label": "会员积分",
           "path": "membershippoints",
           "navTitle": "报表/会员积分"
         },{
           "id": 150204,
           "label": "消费排行",
           "path": "consumptionranking",
           "navTitle": "报表/消费排行"
         }, {
           "id": 150205,
           "label": "商品排行",
           "path": "productranking",
           "navTitle": "报表/商品排行"
         }, ]
       }
     ]
   },
 ]

 export default {
   cyNav
 }



// WEBPACK FOOTER //
// ./src/assets/StaticResources/cyNav.js